// extracted by mini-css-extract-plugin
export default {"ariaLive":"src-signer-app-utils-use-aria-live-module__ariaLive--2d_xd"};